import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/Store';
export var showFilterDropDownContextMenu = action('showFilterDropDownContextMenu')(function () {
    getStore().filterContextMenuDisplayState = true;
});
export var hideFilterDropDownContextMenu = action('hideFilterDropDownContextMenu')(function () {
    getStore().filterContextMenuDisplayState = false;
});
//# sourceMappingURL=filterContextMenuAction.js.map